// extracted by mini-css-extract-plugin
module.exports = {"counterContainer":"RowFormCounter_counterContainer__1cN0j"};